// Driver
export const GET_ALL_DRIVERS = 'GET_ALL_DRIVERS';
export const GET_ONE_DRIVER = 'GET_ONE_DRIVER';
export const CREATE_DRIVER = 'CREATE_DRIVER';
export const DELETE_DRIVER = 'DELETE_DRIVER';
export const UPDATE_DRIVER = 'UPDATE_DRIVER';

//Bus
export const GET_ALL_BUSES = 'GET_ALL_BUSES';
export const CREATE_BUS = 'CREATE_BUS';
export const GET_ONE_BUS = 'GET_ONE_BUS';
export const DELETE_BUS = 'DELETE_BUS';
export const UPDATE_BUS = 'UPDATE_BUS';

//Supervisor
export const GET_ALL_SUPERVISOR = 'GET_ALL_SUPERVISOR';
export const GET_ONE_SUPERVISOR = 'GET_ONE_SUPERVISOR';
export const CREATE_SUPERVISOR = 'CREATE_SUPERVISOR';
export const DELETE_SUPERVISOR = 'DELETE_SUPERVISOR';
export const UPDATE_SUPERVISOR = 'UPDATE_SUPERVISOR';

//Parent
export const GET_ALL_PARENT = 'GET_ALL_PARENT';
export const GET_ONE_PARENT = 'GET_ONE_PARENT';
export const CREATE_PARENT = 'CREATE_PARENT';
export const DELETE_PARENT = 'DELETE_PARENT';
export const UPDATE_PARENT = 'UPDATE_PARENT';
//Student
export const GET_ALL_STUDENT = 'GET_ALL_STUDENT';
export const GET_ONE_STUDENT = 'GET_ONE_STUDENT';
export const CREATE_STUDENT = 'CREATE_STUDENT';
export const DELETE_STUDENT = 'DELETE_STUDENT';
export const UPDATE_STUDENT = 'UPDATE_STUDENT';
export const GET_ALL_STUDENT_WITH_PARENT = 'GET_ALL_STUDENT_WITH_PARENT';

//admin login
export const LOGIN_ADMIN = 'LOGIN_ADMIN';
export const LOGOUT_ADMIN = 'LOGOUT_ADMIN';

//error
export const GET_ERROR = 'GET_ERROR';
